// extracted by mini-css-extract-plugin
export default {"updated_date":"lastUpdated_updated_date__Su4EQ","refresh":"lastUpdated_refresh__FS1y5"};